import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  id: "section-banner",
  class: "section-banner",
  style: {
    "position": "sticky",
    "height": "2.2rem"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "0.64rem",
    "height": "0.64rem",
    "position": "absolute",
    "right": "0.6rem",
    "top": "0.7rem"
  },
  src: "/moblie/images/aftersale-banner01.png"
};
const _hoisted_3 = {
  key: 1,
  style: {
    "width": "0.64rem",
    "height": "0.64rem",
    "position": "absolute",
    "right": "0.6rem",
    "top": "0.7rem"
  },
  src: "/moblie/images/aftersale-banner02.png"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "custservi-banner01",
  src: "/moblie/images/custservi-banner01.jpg"
}, null, -1);

const _hoisted_5 = {
  class: "title"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "custservi-banner02",
  src: "/moblie/images/custservi-banner02.jpg"
}, null, -1);

const _hoisted_7 = {
  class: "custservi-txt"
};
const _hoisted_8 = {
  class: "d-flex align-content-start banner-txtgroup"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "banner-icon",
  src: "/moblie/images/section-banner-icon01.png"
}, null, -1);

const _hoisted_10 = {
  class: "txt-l"
};
const _hoisted_11 = {
  class: "txt-m"
};
const _hoisted_12 = {
  class: "d-flex align-content-start banner-txtgroup"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "banner-icon",
  src: "/moblie/images/section-banner-icon02.png"
}, null, -1);

const _hoisted_14 = {
  class: "txt-l"
};
const _hoisted_15 = {
  class: "txt-s",
  style: {
    "color": "white"
  }
};
const _hoisted_16 = {
  class: "txt-s",
  style: {
    "color": "white"
  }
};
const _hoisted_17 = {
  class: "txt-s",
  style: {
    "color": "white"
  }
};
const _hoisted_18 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_collapse_item = _resolveComponent("van-collapse-item");

  const _component_van_collapse = _resolveComponent("van-collapse");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [$data.activeNamestwo.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nav-zd-open",
    onClick: _cache[0] || (_cache[0] = $event => $data.activeNamestwo = []),
    onTouchstart: _cache[1] || (_cache[1] = $event => $data.activeNamestwo = [])
  }, null, 32)) : _createCommentVNode("", true), _createVNode(_component_van_collapse, {
    modelValue: $data.activeNamestwo,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeNamestwo = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_collapse_item, {
      name: "1"
    }, {
      "right-icon": _withCtx(() => [$data.activeNamestwo.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))]),
      title: _withCtx(() => [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('knowledgeAndSupportTicketSystem')), 1)]),
      default: _withCtx(() => [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('knowledgeCenterSystem')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('findSolutionInKnowledgeCenter')), 1)])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('ContactCustomerSupport')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('LiveChatisopenMondaytoSunday')), 1), _createElementVNode("div", _hoisted_16, _toDisplayString($data.timeText.am), 1), _createElementVNode("div", _hoisted_17, _toDisplayString($data.timeText.pm), 1)])])]), _createElementVNode("div", {
        class: "txt-s",
        innerHTML: _ctx.$t('IfNoSolutionIsAvailable')
      }, null, 8, _hoisted_18)])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}